// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M52Mo","rootNoMargin":"styles_rootNoMargin__3lRTO"};